(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceLevelController', InsuranceLevelController);

    InsuranceLevelController.$inject = ['InsuranceLevel', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function InsuranceLevelController(InsuranceLevel, CoreService, GenericEntityDatatableService, $q,
                                      $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Insurance Level',
            entityClassHumanized: 'Insurance Level',
            entityStateName: 'insurance-level',
            service: InsuranceLevel,
            serviceMethod: 'findAllByCorporation',
            newButtonTitle: 'New Insurance Level',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Level',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-level/update/insurance-level-dialog.html',
                controller: 'InsuranceLevelDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-level/update/insurance-level-dialog.html',
                controller: 'InsuranceLevelDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceLevel', function (InsuranceLevel) {
                        return InsuranceLevel.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Level').result.then(function () {
                    InsuranceLevel.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
